import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import {
  cameraToggleState,
  imgBase64State,
  imgFileState,
  isOpenEmojiState
} from "../../../../recoil/contentsAtom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { faFaceSmile } from "@fortawesome/free-regular-svg-icons";

function PopPageBtns(props: { writeType: string }) {
  const setIsOpenEmoji = useSetRecoilState(isOpenEmojiState);
  const setImgBase64 = useSetRecoilState(imgBase64State);
  const setImgFile = useSetRecoilState(imgFileState);
  const setCameraToggle = useSetRecoilState(cameraToggleState);

  const handleAddImgWrite = (e: React.ChangeEvent<HTMLInputElement>) => {
    let uploadFile: FileList | null = e.target.files;
    setImgFile(uploadFile);
    setImgBase64([]);

    let len = uploadFile?.length || 0;

    for (let i = 0; i < len; i++) {
      let files = e.target.files!;
      if (files[i]) {
        setCameraToggle(true);
        let reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onloadend = () => {
          const base64 = reader.result;
          if (base64) {
            let base64Sub = base64.toString();
            setImgBase64((imgBase64) => [...imgBase64, base64Sub]);
          }
        };
      }
    }
  };

  const handleAddImgComments = (e: React.ChangeEvent<HTMLInputElement>) => {
    let uploadFile: FileList | null = e.target.files;
    setImgFile(uploadFile);
    setImgBase64([]);

    let file = e.target.files!;
    if (file[0]) {
      setCameraToggle(true);
      let reader = new FileReader();
      reader.readAsDataURL(file[0]);
      reader.onloadend = () => {
        const base64 = reader.result;
        if (base64) {
          let base64Sub = base64.toString();
          setImgBase64([base64Sub]);
        }
      };
    }
  };

  return (
    <div className="btn-wrap images">
      <ul className="f-right re-reply-activity clearfix">
        <li className="li-camera">
          <label htmlFor="pop_img">
            <FontAwesomeIcon icon={faCamera} />
          </label>
          <input
            type="file"
            accept=".gif, .jpg, .png, .bmp"
            id="pop_img"
            onChange={
              props.writeType === "comments"
                ? handleAddImgComments
                : handleAddImgWrite
            }
            multiple={props.writeType === "comments" ? false : true}
          />
        </li>
        <li
          className="li-emoji clearix"
          onClick={() => setIsOpenEmoji((prev) => !prev)}
        >
          <Link to="#">
            <FontAwesomeIcon icon={faFaceSmile} />
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default PopPageBtns;
